import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { StartPageProducedElectricity } from "../StartPage.types";

function useStartPageProducedElectricity(year: number, projectId?: string) {
  const { data, error, isLoading } = useQuery({
    queryKey: urls.startPage.producedElectricity.key(year, projectId),
    queryFn: () => fetchStartPageProducedElectricity(year, projectId)
  });

  return { data, error, isLoading };
}

async function fetchStartPageProducedElectricity(
  year: number,
  projectId?: string
) {
  const response =
    await apiWithoutCamelization.get<StartPageProducedElectricity>(
      urls.startPage.producedElectricity.url(year, projectId)
    );
  return response.data;
}

export { useStartPageProducedElectricity };
